import { CourseContentQuery, CourseBasicsQuery } from '@/components/common/blocks/CourseContent';
export async function fetchCourseContent(courseHandle, withContents = true) {
  const { $graphql, $config } = useNuxtApp();

  const response = await $graphql(
    $config.public.fegApiBase,
    withContents ? CourseContentQuery : CourseBasicsQuery,
    {
      handle: courseHandle,
      language: 'de',
    },
    {
      Authorization: `Basic ${$config.public.fegApiAuth}`,
    }
  );

  return response ? response.learnWorldsCourse : null;
}
